(function () {
class TabletopCommonsWeekly extends HTMLElement {
  connectedCallback() {
    this.api = window.TtcEventsApi;
    this.grid = this.querySelector('[data-weekly-events]');
    this.note = this.querySelector('[data-weekly-live-note]');
    this.store = null;

    const apiBase = this.dataset.abblApiBase?.trim();
    if (!this.api || !apiBase) {
      this.showState('The weekly schedule is temporarily unavailable.');
      return;
    }

    this.load(apiBase);
  }

  async load(apiBase) {
    try {
      const result = await this.api.getWeekly(apiBase);
      this.store = result.store || null;
      const requestedTags = this.api.normaliseTags(this.dataset.abblTags?.split(','));
      const matchMode = this.dataset.tagMatch === 'all' ? 'all' : 'any';
      const events = result.events
        .filter((event) => this.api.startDate(event))
        .filter((event) => !requestedTags.length || this.api.matchesTags(event, requestedTags, matchMode));
      const grouped = this.groupByWeekday(events);

      if (this.grid) {
        this.grid.innerHTML = grouped.length
          ? grouped.map(({ day, events: dayEvents }) => this.weekdayColumn(day, dayEvents)).join('')
          : this.emptyState('No recurring sessions are listed right now.');
      }
      if (this.note) this.note.textContent = 'Schedule details are supplied live by Abbl and show the next valid occurrence.';
    } catch (error) {
      console.warn('Tabletop Commons weekly schedule: live data unavailable.', error);
      this.showState('The weekly schedule is temporarily unavailable.');
      if (this.note) this.note.textContent = 'The live weekly feed could not be reached.';
    }
  }

  groupByWeekday(events) {
    const dayOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    const groups = new Map();
    events.forEach((event) => {
      const start = this.api.startDate(event);
      const zone = this.api.timeZone(event, this.store);
      const day = this.api.formatDate(start, { weekday: 'long' }, zone);
      if (!groups.has(day)) groups.set(day, []);
      groups.get(day).push(event);
    });

    return [...groups.entries()]
      .sort(([left], [right]) => dayOrder.indexOf(left) - dayOrder.indexOf(right))
      .map(([day, dayEvents]) => ({
        day,
        events: dayEvents.sort((left, right) => this.api.startDate(left) - this.api.startDate(right))
      }));
  }

  weekdayColumn(day, events) {
    return `<div class="ttc-events__day"><strong class="ttc-events__day-name">${this.api.escapeHtml(day)}</strong>${events.map((event) => this.weeklyEvent(event)).join('')}</div>`;
  }

  weeklyEvent(event) {
    const name = this.api.first(event?.name, event?.Name, 'Tabletop Commons event');
    const start = this.api.startDate(event);
    const end = this.api.endDate(event);
    const zone = this.api.timeZone(event, this.store);
    const startLabel = this.api.formatDate(start, { hour: 'numeric', minute: '2-digit' }, zone);
    const endLabel = this.api.formatDate(end, { hour: 'numeric', minute: '2-digit' }, zone);
    const timeLabel = endLabel ? `${startLabel}–${endLabel}` : startLabel;
    const price = this.api.priceDisplay(event);
    const url = this.api.eventUrl(event);
    const title = this.api.canBook(event)
      ? `<a href="${this.api.escapeHtml(url)}">${this.api.escapeHtml(name)}</a>`
      : `<strong>${this.api.escapeHtml(name)}</strong>`;
    return `<div class="ttc-events__weekly-event">${title}<span>${this.api.escapeHtml(`${timeLabel}${price ? ` · ${price}` : ''}`)}</span></div>`;
  }

  emptyState(heading) {
    return `<div class="ttc-events__empty"><strong>${this.api.escapeHtml(heading)}</strong></div>`;
  }

  showState(heading) {
    if (this.grid) this.grid.innerHTML = this.api ? this.emptyState(heading) : `<div class="ttc-events__empty"><strong>${heading}</strong></div>`;
  }
}

if (!customElements.get('tabletop-commons-weekly')) {
  customElements.define('tabletop-commons-weekly', TabletopCommonsWeekly);
}
})();
